import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { http } from "wagmi";
import { base, mainnet } from "wagmi/chains";
import { collectionName, robinhood } from "./config";

export const wagmiConfig = getDefaultConfig({
  appName: collectionName,
  projectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || "nftforge-dev",
  chains: [base, mainnet, robinhood],
  transports: {
    [base.id]: http(),
    [mainnet.id]: http(),
    [robinhood.id]: http(),
  },
  ssr: false,
});
